import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../assets/Icons";
import IconRoundButton from "../../../components/_utils/CommonButtons/IconRoundButton";
import SecondaryButton from "../../../components/_utils/CommonButtons/SecondaryButton";
import { toast_position } from "../../../redux/features/Settings/Authorization";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

const MessagePanel = ({
  open,
  activeLabel,
  closePanel,
  beneAccountsCount,
  setAlertCount,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const services = useSelector((state) => state.refreshToken.services);
  const [isBYOK, setIsBYOK] = useState(false);

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const entityHasBeenChanged = markerData;

  // useEffect(() => {
  //   const fetchCloudKeys = async () => {
  //     try {
  //
  //       const encryptResult = await dispatch(encryptCloudKeys(""));
  //       const isEnabled = encryptResult?.payload;
  //       const cloudKeyRes = await dispatch(cloudKeyList());
  //       const cloudKeyResult = cloudKeyRes?.payload;
  //       setIsEncryptEnabled(!!isEnabled);
  //       setCloudKey(!cloudKeyResult);
  //     } catch (error) {
  //       console.error("Failed to fetch BYOK details:", error);
  //       setIsEncryptEnabled(false);
  //       setCloudKey(false);
  //     }
  //   };

  //   fetchCloudKeys();
  // }, [dispatch, beneAccountsCount, isEncryptEnabled, cloudKey]);

  const handleBeneAcctView = () => {
    if (beneAccountsCount === 0) {
      return;
    }

    if (
      services?.includes("Admin") ||
      (services?.includes("BVAccount") &&
        services?.includes("PLogin") &&
        services?.includes("BUAccount"))
    ) {
      navigate("/home/unassign_multi_categories");
    } else {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "Admin, BVAccount, PLogin, BUAccount",
        },
      });
    }
  };

  const handleInternalRecreate = () => {
    toast.info("Coming soon", toast_position);
  };

  const handleBeneRecreate = () => {
    toast.info("Coming soon", toast_position);
  };

  const viewAllBYOK = () => {
    if (services?.includes("PLogin")) {
      setIsBYOK(true);
      navigate("/settings/security_center/BYOK");
    } else {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "PLogin",
        },
      });
    }
  };

  const alertContentRaw = [
    {
      mainText: "Recreate beneficiary transactions - 00",
      subText:
        "There are some beneficiary transactions that failed and require your action.",
      viewAllFunct: handleBeneRecreate,
      show: false,
    },
    {
      mainText: "Recreate internal transactions - 00",
      subText:
        "There are some internal transactions that failed and require your action.",
      viewAllFunct: handleInternalRecreate,
      show: false,
    },
    {
      mainText: `Unsafe beneficiary accounts found - ${
        beneAccountsCount?.toLocaleString?.() ?? "0"
      }`,
      subText:
        "All categories are assigned to these accounts. Assigning all categories to a single account is highly unsafe.",
      isDisabled: beneAccountsCount === GlobalConfiguration?.lengthCheckZero,
      viewAllFunct: handleBeneAcctView,
    },

    // {
    //   mainText: Security centre - BYOK,
    //   subText: Your data is currently unprotected. Setup the encryption to protect it now.,
    //   viewAllFunct: viewAllBYOK,
    //   isBYOK: true,
    //   show: isEncryptEnabled || cloudKey,
    // },
  ];

  const alertContent = alertContentRaw.filter((item) => item.show);

  const announcementsContent = [
    {
      mainText: "Happy Transacting!",
      subText:
        "Updated version of app (dev version) is available. You can download it from the play store. Happy transacting!",
      user: {
        name: "Akshay Rangnekar",
        initial: "A",
        timeAgo: "2 hours ago",
      },
    },
  ];

  const renderContentBox = (data, index) => {
    const isBYOKActive = data?.isBYOK ?? false;

    return (
      <div className="relative">
        <div
          key={index}
          className="max-w-[520px] bg-primary-card rounded-border-radius-sm flex flex-col p-padding-md"
        >
          <p className="text-sm font-semibold text-text-primary pb-padding-xs pr-padding-md">
            {data?.mainText}
          </p>
          <p className="text-xs pb-padding-sm text-text-secondary">
            {data?.subText}
          </p>

          <div className="flex-grow" />

          <div className="absolute bottom-bottom-base right-right-base m-margin-base">
            <SecondaryButton
              btnText={isBYOKActive ? "Encrypt now" : "View all"}
              handleFunction={data.viewAllFunct}
              enabled={!data?.isDisabled}
              enabledBgColor="var(--primary-act)"
              enabledTextColor="var(--text-primary)"
            />
          </div>
        </div>
      </div>
    );
  };

  const renderAnnouncementBox = (data, index) => (
    <div
      key={index}
      className={`max-w-recipient-card-width lg:w-recipient-card-width sm:w-width-full xs:w-width-full h-full bg-primary-card p-padding-md rounded-border-radius-sm flex flex-col ${
        index !== 0 ? "mt-margin-md" : ""
      }`}
    >
      <div>
        <p className="text-sm font-semibold text-text-primary pb-padding-xs">
          {data?.mainText}
        </p>
        <p className="text-xs text-text-secondary">{data?.subText}</p>
      </div>

      {data?.user && (
        <div className="flex justify-between items-center pt-padding-sm">
          <div className="flex items-center gap-gap-xs">
            <div className="bg-Selected-MUIinput rounded-full flex items-center justify-center text-text-primary font-semibold text-xs leading-none">
              {data.user.initial}
            </div>
            <p className="text-text-primary font-semibold text-xs">
              {data.user.name}
            </p>
          </div>
          <p className="text-text-secondary text-xs">{data.user.timeAgo}</p>
        </div>
      )}
    </div>
  );

  const getMessageContent = () => {
    switch (activeLabel?.toLowerCase()) {
      case "alert":
        return {
          icon: ICONS?.ALERT,
          message: "The following items require your attention.",
          content: alertContent.map(renderContentBox),
        };

      case "announcement":
        return {
          icon: ICONS?.ANNOUNCEMENT_GREY,
          message: "Important update: Please review the details below!",
          content: announcementsContent.map(renderAnnouncementBox),
        };
      default:
        return {};
    }
  };

  const { icon, message, content } = getMessageContent();

  // useEffect(() => {
  //

  //   const actionableAlerts = alertContent.filter((item) => item.show);
  //   setAlertCount(actionableAlerts.length);
  // }, [dispatch, beneAccountsCount, entityHasBeenChanged]);

  if (!open || !activeLabel) return null;

  return (
    <>
      <div
        className="fixed top-top-base left-left-base w-screen h-screen bg-PopUp-BackDrop opacity-dark-opacity z-z-index-fixed-ui"
        onClick={closePanel}
      ></div>
      <div className="flex justify-center items-center h-screen w-width-full fixed top-top-base left-left-base z-z-index-modal px-padding-md">
        <div className="popup-container rounded-lg py-padding-md px-padding-md w-width-full overflow-y-auto animate-none Qmd:animate-slideInFromRight">
          <div className="flex items-start justify-between w-width-full mb-margin-md">
            <div className="flex-1">
              <h2
                className={`text-base font-semibold flex items-center gap-x-gap-sm capitalize text-text-primary mb-margin-xs`}
              >
                {icon && (
                  <img
                    src={icon}
                    alt={activeLabel}
                    className="w-icon-md h-iconw-icon-md"
                  />
                )}
                {`${activeLabel}s`}
              </h2>
              <p className="text-xs text-text-primary">{message}</p>
            </div>

            <IconRoundButton
              enabledBgColor="var(--primary-nav)"
              isLoading={false}
              handleFunction={closePanel}
              icon={ICONS?.CLOSE}
              hoverOption="white"
            />
          </div>

          <div className="overflow-y-auto w-width-full">{content}</div>
        </div>
      </div>
    </>
  );
};

export default MessagePanel;
